module.exports = __webpack_public_path__ + "img/20_dice[1].e32e1cec.png";